import { configQuery, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_JURISDICTION_QUERY } from '@gig/magic-messages';
import { CoreXMediatorType } from '@gig/magic-sdk/dist/adapter/responsiblegaming/createUserTransactionLimit';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';
import { toSeconds, parse } from 'iso8601-duration';
import { Jurisdiction } from '@gig/magic-jurisdictions';

var RealityCheckComponent = /** @class */ (function (_super) {
    __extends(RealityCheckComponent, _super);
    function RealityCheckComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Whether the duration options are enabled in the UI or not
         */
        _this.disableOptions = null;
        _this.duration = null;
        _this.options = [];
        _this.isSubmitting = false;
        _this.removeNoneOption = false;
        return _this;
    }
    RealityCheckComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jurisdiction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserOptions()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getUserInterval()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 3:
                        jurisdiction = _a.sent();
                        this.disableOptions = jurisdiction === Jurisdiction.ONJN;
                        this.removeNoneOption = jurisdiction === Jurisdiction.SGA;
                        return [2 /*return*/];
                }
            });
        });
    };
    RealityCheckComponent.prototype.getUserOptions = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var options;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, configQuery('realityCheckDurations')];
                    case 1:
                        options = (_a = (_b.sent())) !== null && _a !== void 0 ? _a : [];
                        this.options = options.sort(function (a, b) { return a - b; });
                        return [2 /*return*/];
                }
            });
        });
    };
    RealityCheckComponent.prototype.getUserInterval = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userInterval, duration;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, magic.methods.users.getUserRealityCheckConfigs()];
                    case 1:
                        userInterval = _a.sent();
                        if (userInterval[0].interval) {
                            duration = toSeconds(parse(userInterval[0].interval)) / 60;
                            this.duration = "" + duration;
                        }
                        else {
                            this.duration = '0';
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RealityCheckComponent.prototype.saveRealityCheck = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isSubmitting || this.disableOptions) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.isSubmitting = true;
                        params = {
                            interval: this.getIntervalForDuration(this.duration),
                            mediatorType: CoreXMediatorType.CASINO,
                        };
                        return [4 /*yield*/, magic.methods.users.setUserRealityCheckInterval(params)];
                    case 2:
                        response = _a.sent();
                        if (response) {
                            notificationService.show(this.$t('reality-check.success-notification'), {
                                style: NotificationStyle.SUCCESS,
                                uniqueID: 'reality-check.success-notification',
                            });
                        }
                        else {
                            this.showErrorNotification();
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        this.showErrorNotification();
                        return [3 /*break*/, 5];
                    case 4:
                        this.isSubmitting = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    RealityCheckComponent.prototype.getIntervalForDuration = function (duration) {
        if (duration === '0') {
            return null;
        }
        return "PT" + duration + "M";
    };
    RealityCheckComponent.prototype.showErrorNotification = function () {
        notificationService.show(this.$t('error.generic'), {
            style: NotificationStyle.ERROR,
            uniqueID: 'reality-check-error-generic',
        });
    };
    RealityCheckComponent = __decorate([
        Component({
            name: 'corex-reality-check',
        })
    ], RealityCheckComponent);
    return RealityCheckComponent;
}(Mixins(MagicConfigMixin)));

export default RealityCheckComponent;
